import type { OcrResultStatus } from '../types';

/**
 * The statuses the UI ever renders. `pending` is absent on purpose — see
 * `displayOcrStatus`.
 */
export type DisplayOcrStatus = Exclude<OcrResultStatus, 'pending'>;

/**
 * Collapse `pending` into `processing` for display.
 *
 * Mirrors the `ocr_status` CASE in `OcrService::listContainers`, which folds
 * both into one bucket because "dispatched" vs. "claimed by a worker" is a
 * queue-internal detail that means "OCR is running" to an operator. Every
 * detail surface must apply the same collapse or the same container reads
 * `معلق` on its results page while the listing reads `قيد المعالجة`.
 *
 * Keep in sync with that CASE and with the `ocr_status` filter that widens
 * `processing` back onto both underlying statuses.
 */
export function displayOcrStatus(status: OcrResultStatus): DisplayOcrStatus {
  return status === 'pending' ? 'processing' : status;
}
